import {useEffect, useState} from 'react';
import {apiMethod, APIService} from '../APIService';
import {
  APIResponseStatus,
  LocalStorageKeys,
  UserSettings,
} from '../../common/types';
import {useDispatch} from 'react-redux';
import {useSnackbar} from 'notistack';
import {useIntl} from 'react-intl';
import {setUserSettings} from '../../store/userSettings/reducer';

class UsersSettingsAPI extends APIService {
  fetchSettings = apiMethod(
    () => this.fetcher.request({
      method: 'GET',
      url: `/api/users/settings/`,
    }),
  );
}

export {UsersSettingsAPI};

export const useFetchUserSettings = () => {
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const {formatMessage} = useIntl();
  const api = new UsersSettingsAPI();

  useEffect(() => {
    api.fetchSettings()
      .then(response => {
        if (response.status === APIResponseStatus.Ok) {
          localStorage.removeItem(LocalStorageKeys.BadgesDismiss);

          dispatch(setUserSettings(response.data));
        }
      })
      .catch(error => {
        console.debug(error);
        snackbar.enqueueSnackbar(
          formatMessage({id: 'errors.general'}),
          {key: 'user_settings_global'},
        );
      });
  }, []);
};
